import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=46dc82a5&scoped=true"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc82a5",
  null
  
)

export default component.exports